import { api } from '../../../services/api';

export interface MergeBody {
  survivorId: string;
  mergedIds: string[];
  survivorPatch?: {
    description?: string;
    amount?: number;
    transactionDate?: string;
    categoryId?: string | null;
    notes?: string;
  };
}

export interface MergeResult {
  survivor: { id: string };
  mergedCount: number;
  affectedPayouts: number;
}

export interface SuggestArgs {
  companyId: string;
  date: string;
  amount: number;
  type: 'INCOME' | 'EXPENSE';
  toleranceDays?: number;
  toleranceAmount?: number;
}

export interface MatchSuggestion {
  transactions: Array<{
    id: string;
    transactionDate: string;
    amount: number;
    type: 'INCOME' | 'EXPENSE';
    description: string;
    categoryId: string | null;
  }>;
  net: number;
  deltaToTarget: number;
}

export const reconciliationService = {
  merge: (body: MergeBody) =>
    api
      .post<{ success: boolean; data: MergeResult }>('/financial/reconciliation/merge', body)
      .then((r) => r.data),

  unmerge: (body: { survivorId: string; transactionIds?: string[] }) =>
    api.post('/financial/reconciliation/unmerge', body).then((r) => r.data),

  suggestions: (params: SuggestArgs) =>
    api
      .get<{
        success: boolean;
        data: { matches: MatchSuggestion[] };
      }>('/financial/reconciliation/suggestions', { params })
      .then((r) => r.data),
};
